<!-- 
Inspiration: https://onepagelove.com/cpg-fast-track | https://cpgfasttrack.com/?ref=onepagelove
-->

<body>
  <header class="bg-green-400 p-3 md:p-6">
    <nav class="bg-green-700 w-[-webkit-fill-available] rounded-xl shadow-lg">
      <div class="px-4">
        <div class="flex justify-between h-16 items-center">
          <!-- Logo -->
          <div class="flex-shrink-0 text-white text-2xl font-bold">
            corpers.ng
          </div>

          <!-- Desktop Menu -->
          <div class="hidden md:flex space-x-6 text-white font-medium">
            <a href="/about" class="hover:text-yellow-300 transition">About</a>
            <a href="#services" class="hover:text-yellow-300 transition">Services</a>
            <a href="#contact" class="hover:text-yellow-300 transition">Contact</a>
            <a href="/login" class="hover:text-yellow-300 transition">Login</a>
          </div>

          <!-- Desktop Button -->
          <div class="hidden md:block">
            <a href="/signup" class="bg-white px-4 py-2 rounded hover:bg-yellow-300 transition-all font-semibold">
              Sign up
            </a>
          </div>

          <!-- Mobile Menu Button -->
          <div class="md:hidden">
            <button type="button" (click)="toggleMobileMenu()" class="text-white focus:outline-none">
              <mat-icon class="!size-6 text-2xl">menu</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- Mobile Menu -->
      <div id="mobile-menu" class="md:hidden px-4 pb-4 space-y-2 text-white font-medium"
        [ngClass]="{ hidden: !isMobileMenuOpen }">
        <a href="/about" class="block hover:text-yellow-300 transition">About</a>
        <a href="#services" class="block hover:text-yellow-300 transition">Services</a>
        <a href="#contact" class="block hover:text-yellow-300 transition">Contact</a>
        <a href="/login" class="block hover:text-yellow-300 transition">Login</a>
        <a href="/signup"
          class="block bg-white text-green-950 text-center px-4 py-2 rounded-xl hover:bg-yellow-300 transition-all font-semibold mt-2">
          Sign up
        </a>
      </div>
    </nav>
  </header>

  <section class="lg:bg-[url(/assets/images/trnsprnt.grn.bg.png)] bg-no-repeat bg-right bg-green-400">
    <!-- nice text animation (first sample): https://prismic.io/blog/css-animation-examples -->
    <div class="px-5 py-9 md:p-10 lg:p-28">
      <p class="pb-0 md:pb-3 lg:pb-4 flex md:block font-sans font-bold tw-font-stretch-expanded text-3xl md:text-6xl lg:text-7xl text-green-950">
        Buy&nbsp;<span class="bg-red-400 min-h-[44px] min-w-28 p-1 md:py-0 origin-bottom -rotate-2"><span *ngIf="currentBuyWord" @slideInOut01 class="z-20">{{ currentBuyWord }}.</span></span>
      </p>
      <p class="pb-0 md:pb-3 lg:pb-4 flex md:block font-sans font-bold tw-font-stretch-expanded text-3xl md:text-6xl lg:text-7xl text-green-950">
        Sell your&nbsp;<span class="bg-amber-300 min-h-[44px] min-w-28 p-1 md:py-0 origin-top-left rotate-1 z-10"><span *ngIf="currentSellWord" @slideInOut02>{{currentSellWord}}.</span></span>
      </p>
      <p class="pb-0 md:pb-3 lg:pb-4 font-sans font-bold tw-font-stretch-expanded text-3xl md:text-6xl lg:text-7xl text-green-950">
        Get accommodation. <!-- in Katsina or Lagos? -->
      </p>
      <p class="font-sans font-bold tw-font-stretch-expanded text-3xl md:text-6xl lg:text-7xl text-green-950">
        Find
        <span class="tw-font-stretch-extra-condensed font-extralight font-mono italic">your</span>&nbsp;<a href="/search" class="relative inline-flex items-start group">
          <span class="relative">PPA.</span>
          <mat-icon class="opacity-0 -translate-x-3 transition-all duration-200 group-hover:opacity-100 group-hover:-translate-x-7">arrow_outward</mat-icon>
          <span
            class="absolute left-0 -bottom-0.5 h-1.5 w-0 bg-green-950 transition-all duration-200 group-hover:w-[80%]">
          </span>
        </a>

      </p>
      <p class="text-lg mt-4 mb-5">Ease your NYSC year.</p>

      <a href="/signup" class="rounded px-3 py-2 bg-white text-green-950 hover:bg-yellow-300 transition-all"
        type="button" title="Sign up">
        Sign up
    </a>
    </div>
  </section>

  <section id="services" class="py-16 md:py-24 bg-slate-200">
    <div class="container mx-auto px-6 md:px-12 lg:px-24">
      <h2 class="font-sans font-bold tw-font-stretch-expanded text-3xl md:text-5xl text-green-950 text-center mb-12">
        Essential Services for Every Corp Member
      </h2>
      <div class="grid md:grid-cols-2 md:grid-rows-2 gap-8">
        <a class="bg-gray-50 p-8 rounded-xl flex flex-col lg:flex-row gap-6 cursor-pointer">
          <div>
            <mat-icon class="!size-24 text-8xl text-green-700">apartment</mat-icon>
          </div>

          <div>
            <h3 class="tw-font-stretch-extra-expanded font-sans text-xl font-semibold mb-3 text-gray-800">
              Find Accommodation
            </h3>
            <p class="text-gray-800 font-sans">
              Discover affordable housing options near your PPA
              (Place of Primary Assignment).
            </p>
          </div>
        </a>

        <a class="bg-gray-50 p-8 rounded-xl flex flex-col lg:flex-row gap-6 cursor-pointer">
          <div>
            <mat-icon class="!size-24 text-8xl text-green-700">chat</mat-icon>
          </div>
          <div>
            <h3 class="tw-font-stretch-extra-expanded font-sans text-xl font-semibold mb-3 text-gray-800">
              Chat with Corp Members
            </h3>
            <p class="text-gray-800 font-sans">
              Connect with other corp members, share experiences, and build your
              network.
            </p>
          </div>
        </a>

        <a class="bg-gray-50 p-8 rounded-xl flex flex-col lg:flex-row gap-6 cursor-pointer">
          <div>
            <mat-icon class="!size-24 text-8xl text-green-700">sell</mat-icon>
          </div>
          <div>
            <h3 class="tw-font-stretch-extra-expanded font-sans text-xl font-semibold mb-3 text-gray-800">
              Buy & Find Items for Sale
            </h3>
            <p class="text-gray-800 font-sans">
              Buy and sell essential items, from electronics to household goods,
              within the corp member community.
            </p>
          </div>
        </a>

        <a class="bg-gray-50 p-8 rounded-xl flex flex-col lg:flex-row gap-6 cursor-pointer">
          <div>
            <mat-icon class="!size-24 text-8xl text-green-700">domain</mat-icon>
          </div>
          <div>
            <h3 class="tw-font-stretch-extra-expanded font-sans text-xl font-semibold mb-3 text-gray-800">
              Find PPAs
            </h3>
            <p class="text-gray-800 font-sans">
              Locate your assigned PPA. And help others find theirs too. Leave reviews and feedback for PPAs to help future corp members.
            </p>
          </div>
        </a>
      </div>
    </div>
  </section>

  <section class="bg-green-950 text-white py-16 md:py-20 text-center">
    <div class="container mx-auto px-6 md:px-12 lg:px-24">
      <h2 class="text-3xl md:text-4xl text-green-400 font-bold mb-6">
        Ready to Simplify Your NYSC Journey?
      </h2>
      <p class="text-lg md:text-xl mb-8 max-w-2xl mx-auto text-green-400">
        Join thousands of corp members. Sign up!
      </p>
      <div class="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6">
        <a href="/signup" class="mt-4 rounded px-3 py-2 bg-white text-green-950 hover:bg-yellow-300 transition-all"
          type="button" title="Sign up">
          Sign up
      </a>
      </div>
    </div>
  </section>

  <footer id="contact" class="bg-gray-800 text-white py-10 md:py-12 px-6 md:px-12 lg:px-24">
    <div class="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
      <div>
        <h3 class="text-xl font-bold mb-4">About Us</h3>
        <p class="text-gray-400 text-sm">
          Your reliable companion for a seamless NYSC service year in Nigeria.
        </p>
        <p id="user-id-display" class="text-gray-400 text-xs mt-2 hidden">
          Your User ID: <span class="font-mono break-all"></span>
        </p>
      </div>
      <div>
        <h3 class="text-lg font-semibold mb-4">Quick Links</h3>
        <ul class="space-y-2 text-gray-400 text-sm">
          <li>
            <a href="#services" class="hover:text-white transition duration-300">Services</a>
          </li>
          <li>
            <a href="/about#privacy-policy" class="hover:text-white transition duration-300">Privacy Policy</a>
          </li>
          <li>
            <a href="/about#terms" class="hover:text-white transition duration-300">Terms of Service</a>
          </li>
        </ul>
      </div>
      <div>
        <h3 class="text-lg font-semibold mb-4">Connect With Us</h3>
        <p class="text-gray-400 text-sm mb-4">Email: info&#64;corpers.ng</p>
      </div>
    </div>
    <div class="text-center text-gray-400 text-sm mt-8 pt-6 border-t border-gray-700">
      &copy; {{fullYear}} corpers.ng // All rights reserved
    </div>
  </footer>
</body>